module.exports = __webpack_public_path__ + "static/media/pic____.3ef150fd.png";